// Launch metadata shown beside a trace: executable, command, and OS account.
// The query selects typed fields from the originating notification.
export function shapeSessionOrigin(row) {
  if (!row) return null;
  const imageName = String(row.image_name ?? "");
  const commandLine = String(row.command_line ?? "");
  if (!commandLine && !imageName) return null;
  return {
    imageName,
    commandLine,
    account: String(row.account_name ?? ""),
    domain: String(row.domain_name ?? ""),
    provider: String(row.provider ?? ""),
  };
}
